import $ from "jquery";
import recaptchaEnterprise, { RECAPTCHA_ACTIONS } from "scripts/components/recaptcha/recaptcha";

const globalLocale = $("html").attr("lang");

const BASE_URL = "";

const validateCaptcha = async () => {
  const { token } = await recaptchaEnterprise.executeRecaptcha(RECAPTCHA_ACTIONS.RESERVATION)
  return token;
}

export const getStoresList = async (options = {}) => {
  const { id, locale = globalLocale || "en" } = options;
  return $.ajax({
    url: `${BASE_URL}/api/stocks/${id}`,
    type: "GET",
    cache: false,
    // data: id,
    dataType: "json",
    headers: {
      "Accept-Language": locale,
    },
    success: (response) => {
      // console.log("getStoresList saccess response", response);
    },
    error: (error) => {
      console.log(error);
    },
  });
};

export const reservation = async (isConfirmPhoneStep ,options = {}) => {
  // const {
  //   phone,
  //   name,
  //   sku,
  //   externalShopId,
  //   // gRecaptchaResponse,
  //   locale = "en",
  // } = options;
  const locale = globalLocale || "en";

  try {
    const token = await validateCaptcha();
    if (!isConfirmPhoneStep) {
      delete options.sms_code
    }
    if (token) {
      return $.ajax({
        url: `${BASE_URL}/api/stocks/reservation`,
        type: "POST",
        cache: false,
        data: JSON.stringify({
          ...options,
          locale,
          "g-recaptcha-response": token,
        }),
        dataType: "json",
        contentType: "application/json",
        headers: {
          "Accept-Language": locale,
        },
        success: (response) => {
          // console.log("reservation saccess response: ", response);
        },
        error: (error) => {
          console.log("reservation error:", error);
        },
      }).promise();
    }
  } catch (error) {
    console.log("Reservation error:", error);
  }
};
